import watchNewFilterFluxoCaixa from './saga/newFilter';

export const fluxoCaixaSaga = [
    watchNewFilterFluxoCaixa(),
]

export * from './actionTypes';
export * from './reducer';
export * from './service';
